DOMReady( function(){
  // Pagination semi-intelligente
  [... document.querySelectorAll('.navigation')].map( navigationEl => {
    [... navigationEl.querySelectorAll('.pagination-more')].map( j => {
      j.classList.add('d-none');
      [... navigationEl.querySelectorAll('.more-pages')].map( morepagebutton => {
        morepagebutton.addEventListener( 'click', function (e) {
          if( j.classList.contains('d-none') ){
            j.classList.remove('d-none');
          } else {
            j.classList.add('d-none');
          }
        });
      });
    });
  });
});
